import { render, staticRenderFns } from "./IssuedCertificates.vue?vue&type=template&id=663f5f04&scoped=true&"
import script from "./IssuedCertificates.vue?vue&type=script&lang=js&"
export * from "./IssuedCertificates.vue?vue&type=script&lang=js&"
import style0 from "./IssuedCertificates.vue?vue&type=style&index=0&id=663f5f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f5f04",
  null
  
)

export default component.exports